<template>
<!--      errorMessageKey: {{errorMessageKey}}, errorMessageParam: {{errorMessageParam}}, errorMessage: {{errorMessage}}-->
  <p class="validationerror--message" v-if="errorMessage && !errorMessageParam">{{
    $t(`error.${errorMessage}`)
  }}</p>
  <p class="validationerror--message"
        v-if="errorMessage && errorMessageParam && errorMessageKey === 'min' || errorMessageKey === 'minLength'">{{
      $t(`error.${errorMessageKey}`, {min: errorMessageParam})
    }}</p>
  <p class="validationerror--message"
        v-if="errorMessage && errorMessageParam && errorMessageKey === 'max' || errorMessageKey === 'maxLength'">{{
      $t(`error.${errorMessageKey}`, {max: errorMessageParam})
    }}</p>
</template>

<script lang="ts">
import {computed, defineComponent} from "vue";

export default defineComponent({
  name: "FieldInputErrorMessage",
  props: {
    errorMessage: {
      type: String,
      default: "",
    },
  },
  setup(props) {

    const separator = "_";

    const errorMessageKey = computed(() => {
      return props.errorMessage?.split(separator)[0];
    });

    const errorMessageParam = computed(() => {
      return props.errorMessage?.split(separator)[1];
    });

    return {
      errorMessageParam,
      errorMessageKey
    }
  }
});
</script>

<style scoped>

</style>
